import React, { useRef } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import html2canvas from "html2canvas";
import burger from "../../../assets/qrcode/burger.png";
import pngLogo from "../../../assets/sebs/sebs.png";
import "./QrModal.css";
import { QRCodeCanvas } from "qrcode.react";
import sebs from "../../../assets/sebs/sebs.png";

const QrModal = ({ isOpen, toggle, url, data }) => {
  const modalRef = useRef(null);

  const downloadAsImage = async () => {
    try {
      const modalElement = modalRef.current;

      const canvas = await html2canvas(modalElement, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#f0f7ff",
        logging: false,
      });

      canvas.toBlob((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${data?.name || 'qr-code'}-menu.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 'image/jpeg', 1.0);
    } catch (error) {
      console.error("Error generating image:", error);
    }
  };

  const handlePrint = async () => {
    try {
      const modalElement = modalRef.current;

      const canvas = await html2canvas(modalElement, {
        scale: 2, // Higher scale for better print quality
        useCORS: true,
        backgroundColor: "#f0f7ff",
        logging: false,
      });

      // Create a new window
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        alert('Please allow popups to print');
        return;
      }

      // Add the canvas as an image to the new window
      printWindow.document.write(`
        <html>
          <head>
            <title>Print QR Code</title>
            <style>
              @media print {
                body {
                  margin: 0;
                  padding: 0;
                }
                img {
                  width: 100%;
                  height: auto;
                }
              }
            </style>
          </head>
          <body>
            <img src="${canvas.toDataURL('image/jpeg', 1.0)}" />
            <script>
              window.onload = function() {
                window.print();
                window.onafterprint = function() {
                  window.close();
                }
              }
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    } catch (error) {
      console.error("Error printing:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="modal">
      <style>
        {`
        .modal-content {
          width: 27rem;
          border: none !important;
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }
        
        @media (max-width: 576px) {
          .modal-dialog {
            margin: 0.5rem auto;
            max-width: 20rem !important;
          }
          .modal-content {
            width: 20rem !important;
          }
        }

        .action-buttons {
          position: fixed;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1050;
          display: flex;
          gap: 10px;
        }

        .action-btn {
          background-color: #f74a4a;
          border: none;
          padding: 8px 20px;
          border-radius: 5px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          transition: all 0.3s ease;
        }

        .action-btn:hover {
          background-color: #f63535;
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
          transform: translateY(-2px);
        }

        .action-btn:active {
          transform: translateY(0);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }

        @media print {
          .action-buttons {
            display: none;
          }
          .modal-content {
            width: 100% !important;
          }
        }
      `}
      </style>
      <div className="model-container-one d-print" ref={modalRef}>
        <div className="top-container">
          <img
            src={`data:image/png;base64,${data?.logo}`}
            className="restro-logo"
            crossOrigin="anonymous"
          />
          <p className="restro-name">{data?.name || ""}</p>
          <p className="digital-menu">Digital Menu</p>
        </div>
        <div className="bottom-container d-print">
          <div className="qr-code">
            <QRCodeCanvas
              value={url}
              size={180}
              bgColor="#f0f7ff"
              fgColor="#000000"
              level="H"
            />
          </div>
          <div>
            <p className="scan-here">Scan Here</p>
            <p className="view digital">To View Digital Menu Online</p>
          </div>
          <div className="bottom-last-container">
            <div className="border-generator"></div>
            <img src={burger} className="food-img-qr" crossOrigin="anonymous" />
            <div className="compay-detail d-flex flex-column justify-content-start align-items-end w-100">
              <p className="company-address  d-flex align-items-center justify-content-start" style={{ width: "170px", marginBottom: "1px" }}>
                <span className="rounded-circle btn-sm d-flex align-items-center justify-content-center" style={{ backgroundColor: "#fead1d", width: "25px", height: "25px" }}>
                  <i className="bx bx-map fs-5"></i>
                </span>
                {data?.address1 || ""}
              </p>
              <p className="company-address  d-flex align-items-center justify-content-start" style={{ width: "170px", marginBottom: "1px" }}>
                <span className="rounded-circle btn-sm d-flex align-items-center justify-content-center" style={{ backgroundColor: "#fead1d", width: "25px", height: "25px" }}>
                  <i className="bx bx-envelope fs-5"></i>
                </span>
                {data?.email || ""}
              </p>
              <p className="company-address  d-flex align-items-center justify-content-start" style={{ width: "170px", marginBottom: "1px" }}>
                <span className="rounded-circle btn-sm d-flex align-items-center justify-content-center" style={{ backgroundColor: "#fead1d", width: "25px", height: "25px" }}>
                  <i className="bx bx-phone fs-5"></i>
                </span>
                {data?.contactNo || ""}
              </p>
              <div className="w-50 text-center d-flex flex-column justify-content-end align-items-center">
                <h6 className="powered-by text-white text-end" style={{ fontSize: "12px", width: "100%", marginRight: "2rem" }}>Powered By</h6>
                <img src={sebs} className="company-logo" style={{ width: "150px", height: "auto" }} crossOrigin="anonymous" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="action-buttons d-print-none">
        <Button className="action-btn" onClick={downloadAsImage}>
          Download QR
        </Button>
        <Button className="action-btn" onClick={handlePrint}>
          Print QR
        </Button>
      </div>
    </Modal>
  );
};

export default QrModal;